import React from 'react';

import './App.css'
import '@shopify/polaris/build/esm/styles.css';

import { AppProvider } from '@shopify/polaris';
import { NavMenu } from '@shopify/app-bridge-react';
import enTranslations from '@shopify/polaris/locales/en.json';
import polarisStyles from "@shopify/polaris/build/esm/styles.css?url";

import { NavLink } from './components/NavLink';

import MainPage from './components/MainPage';
import ManageBarcodes from './components/ManageBarcodes';
import PrintBarcodes from './components/PrintBarcodes';
import BarcodeTemplates from './components/BarcodeTemplates';
import LiveModify from './components/LiveModify';
import Add from './components/BulkModify/add';
import Remove from './components/BulkModify/remove';
import Update from './components/BulkModify/update';
import BarcodeActions from './components/BarcodeActions';
import BatchUpdateResults from './components/BatchUpdateResults';
import LiveResults from './components/BatchUpdateResults/LiveResults';
import OrderCreation from './components/OrderCreation';
import PickOrder from './components/PickOrder';
import AppSettings from './components/AppSettings';

import NewTemplateForm from './components/BarcodeTemplates/NewTemplateForm';
import EditTemplateForm from './components/BarcodeTemplates/EditTemplateForm';

import {
  BrowserRouter as Router,
  Route,
  Routes
} from 'react-router-dom';

const App = ({ payload, shopUrl }) => {
  return (
    <>
      <AppProvider i18n={enTranslations}>
        <Router>
          <NavMenu>
            <NavLink to={`/${window.location.search}`} rel="home">
              Home
            </NavLink>
          </NavMenu>
          <Routes>
            <Route path='/' element={<MainPage payload={payload} shopUrl={shopUrl} />} />
            <Route path='/manage' element={<ManageBarcodes payload={payload} shopUrl={shopUrl} />} />
            <Route path='/print' element={<PrintBarcodes payload={payload} shopUrl={shopUrl} />} />
            <Route path='/templates' element={<BarcodeTemplates payload={payload} shopUrl={shopUrl} />} />
            <Route path='/templates/new' element={<NewTemplateForm payload={payload} shopUrl={shopUrl} />} />
            <Route path='/templates/edit/:uuid' element={<EditTemplateForm payload={payload} shopUrl={shopUrl} />} />
            <Route path='/inventory/add' element={<Add payload={payload} shopUrl={shopUrl} />} />
            <Route path='/inventory/remove' element={<Remove payload={payload} shopUrl={shopUrl} />} />
            <Route path='/inventory/update' element={<Update payload={payload} shopUrl={shopUrl} />} />
            <Route path='/inventory/live' element={<LiveModify payload={payload} shopUrl={shopUrl} />} />
            <Route path='/barcode_actions/:barcodeValue' element={<BarcodeActions payload={payload} shopUrl={shopUrl} />} />
            <Route path='/update_results' element={<BatchUpdateResults payload={payload} shopUrl={shopUrl} />} />
            <Route path='/live_results' element={<LiveResults payload={payload} shopUrl={shopUrl} />} />
            <Route path='/order' element={<OrderCreation payload={payload} shopUrl={shopUrl} />} />
            <Route path='/pick/:orderId?' element={<PickOrder payload={payload} shopUrl={shopUrl} />} />
            <Route path='/settings' element={<AppSettings payload={payload} shopUrl={shopUrl} />} />
          </Routes>
        </Router>
      </AppProvider>
    </>
  )
}

export default App;
